import React, { useEffect } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  CircularProgress,
  IconButton
} from '@mui/material';
import {
  ArrowBack,
  Login
} from '@mui/icons-material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';

const LoginPageKeycloak: React.FC = () => {
  const navigate = useNavigate();
  const { keycloak, initialized } = useKeycloak();

  // Redirect to dashboard if already authenticated
  useEffect(() => {
    if (initialized && keycloak.authenticated) {
      navigate('/dashboard');
    }
  }, [initialized, keycloak.authenticated, navigate]);

  const handleLogin = () => {
    keycloak.login();
  };

  if (!initialized) {
    return (
      <Box sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{
      minHeight: '100vh',
      bgcolor: 'background.default',
      display: 'flex',
      alignItems: 'center',
      py: 4
    }}>
      <Container maxWidth="sm">
        {/* Header with back button */}
        <Box sx={{ mb: 4, display: 'flex', alignItems: 'center' }}>
          <IconButton
            component={RouterLink}
            to="/"
            sx={{ mr: 2 }}
            color="primary"
          >
            <ArrowBack />
          </IconButton>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img
              src="/logo-white.svg"
              alt="SenCore Logo"
              style={{ height: '32px' }}
            />
          </Box>
        </Box>

        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Login sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
            <Typography variant="h4" gutterBottom>
              Welcome Back
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Sign in to access your environmental monitoring dashboard
            </Typography>
          </Box>

          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleLogin}
            sx={{ mt: 3, mb: 2, py: 1.5 }}
          >
            Sign In with Keycloak
          </Button>

          <Box sx={{ textAlign: 'center', mt: 3 }}>
            <Typography variant="body2" color="text.secondary">
              Don't have an account?{' '}
              <Button
                component={RouterLink}
                to="/register"
                variant="text"
                sx={{ textTransform: 'none' }}
              >
                Create Account
              </Button>
            </Typography>
          </Box>

          <Box sx={{ mt: 4, p: 2, bgcolor: 'background.default', borderRadius: 1 }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center' }}>
              Secured by Keycloak
            </Typography>
            <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
              Single Sign-On (SSO) authentication
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default LoginPageKeycloak;
